import { z } from 'zod';

import { SecretTypeEnum } from '@/shared/types/types.generated';
import { optionalString, requiredString } from '@/shared/utils/validation';

export const createSecretInputSchema = z.object({
  secretType: z.nativeEnum(SecretTypeEnum),
  name: requiredString(),
  customFields: z.record(z.string(), z.unknown()).optional(),
  username: optionalString(),
  secretValue: requiredString(),
});
